import tw from "twin.macro";

type SelectableRowProps = {
  icon: React.ReactNode;
  iconBg: string;
  iconColor?: string;
  label: string;
  description?: string;
  active: boolean;
  isLast: boolean;
  highlightActive?: boolean;
  activeTextColor?: "green" | "gray";
  onClick: () => void;
  available: boolean;
  trailing?: React.ReactNode;
};

export function SelectableRow({
  icon,
  iconBg,
  iconColor,
  label,
  available,
  active,
  isLast,
  onClick,
  description,
  highlightActive = true,
  activeTextColor = "green",
  trailing,
}: SelectableRowProps) {
  return (
    <button
      type="button"
      disabled={!active && !available}
      css={[
        tw`w-full flex items-center gap-3 px-2 py-3 transition text-left`,
        !isLast && highlightActive && tw`border-b-2 border-white/80`,
        !isLast && !highlightActive && tw`border-b border-gray-200`,
        active && highlightActive && tw`bg-green-100 active:bg-white`,
        !active && !available && tw`opacity-40 cursor-default`,
      ]}
      onClick={available ? onClick : undefined}
    >
      <div
        css={tw`w-10 h-10 rounded-full flex items-center justify-center shrink-0`}
        style={{ backgroundColor: iconBg, color: iconColor }}
      >
        {icon}
      </div>
      <div css={tw`flex flex-col flex-1 min-w-0`}>
        <span
          css={[
            tw`text-sm font-semibold`,
            available
              ? activeTextColor === "gray"
                ? tw`text-gray-800`
                : tw`text-green-800`
              : tw`text-gray-500`,
          ]}
        >
          {label}
        </span>
        {description && (
          <span css={tw`text-xs text-gray-500 mt-0.5`}>{description}</span>
        )}
      </div>
      {trailing}
    </button>
  );
}
